import React from "react";
import PropTypes from "prop-types";
import ApiConfig from "../../../api/ApiConfig";
import g20 from "../../../assets/images/g20.png";

const AnnouncementCard = ({ announcement }) => {
  const imgSrc = announcement.ImagePath
    ? ApiConfig.BASE_URL_FOR_IMAGES + announcement.ImagePath
    : g20;

  const postedDate =
    announcement.Date && announcement.Date.slice(0, 9);

  return (
    <article className="ann-card">
      <header>
        <h3 className="ann-card__title">{announcement.Title}</h3>
        <div className="ann-card__meta">
          {postedDate && (
            <span className="ann-card__meta-item">Posted on {postedDate}</span>
          )}
          {announcement.CreatedBy && (
            <>
              <span className="ann-card__divider" aria-hidden="true" />
              <span className="ann-card__meta-item ann-card__author">
                {announcement.CreatedBy}
              </span>
            </>
          )}
          {announcement.ViewCount !== undefined && (
            <>
              <span className="ann-card__divider" aria-hidden="true" />
              <span className="ann-card__meta-item">
                {announcement.ViewCount}+ Views
              </span>
            </>
          )}
        </div>
      </header>

      <img alt="" className="ann-card__image" src={imgSrc} />

      <p className="ann-card__description">{announcement.Description}</p>
    </article>
  );
};

AnnouncementCard.propTypes = {
  announcement: PropTypes.shape({
    Title: PropTypes.string,
    Date: PropTypes.string,
    CreatedBy: PropTypes.string,
    ViewCount: PropTypes.number,
    Description: PropTypes.string,
    ImagePath: PropTypes.string,
  }).isRequired,
};

export default AnnouncementCard;
